exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3UH9rENzKj6-NsW0NrMKTq{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}._367vDKZZbo2Fz342w6UAmN{width:329px;height:32px}html[dir] ._3pSun3P0vFYZ_X0L02p_3k{padding:0 8px}._2ZevjaHC3AbhgIfcvYekBQ,._3pSun3P0vFYZ_X0L02p_3k{width:100px;height:32px}html[dir=ltr] ._2ZevjaHC3AbhgIfcvYekBQ,html[dir=ltr] ._3pSun3P0vFYZ_X0L02p_3k{margin-left:28px}html[dir=rtl] ._2ZevjaHC3AbhgIfcvYekBQ,html[dir=rtl] ._3pSun3P0vFYZ_X0L02p_3k{margin-right:28px}._2ZevjaHC3AbhgIfcvYekBQ{display:-webkit-box;display:-ms-flexbox;display:flex}", ""]);

// exports
exports.locals = {
	"permissionContainer": "_3UH9rENzKj6-NsW0NrMKTq",
	"dropdownContainer": "_367vDKZZbo2Fz342w6UAmN",
	"sharingButton": "_3pSun3P0vFYZ_X0L02p_3k",
	"spinner": "_2ZevjaHC3AbhgIfcvYekBQ"
};